/* global PegasusTemplate:true */
Em.View.reopen({
  rerender: function(){
    if ( this.get('state') !== 'inDOM' ) { return; }
    this._super();
  }
});

window.PegasusTemplate = Ember.Application.create({
  version: 6668406280223280,
  defaultEmailName: '',
  options: {},
  status: 'loading',
  lastLeaf: null,
  loaded: false,
  nextCopy: 'Continue',
  loadedTemplate: function() {
    return this.lookupController('template').get('content');
  },
  lookupStore: function() {
    // console.log('TODO: remove reference to PegasusTemplate.lookupStore()');
    return this.__container__.lookup('store:main');
  },

  // TODO~ temporary helper - should be removed after refactor
  // it's no longer appropriate to reference PegasusTemplate.router
  lookupRouter: function() {
    // console.log('TODO: remove reference to PegasusTemplate.lookupRouter()');
    return this.__container__.lookup('router:main');
  },

  // TODO~ temporary helper - should be removed after refactor
  // oauth_complete.html.haml needs to call didCompleteOauth on SocialAccounts controller
  lookupController: function(controllerName, options) {
    // console.log('TODO: remove reference to PegasusTemplate.lookupController()');
    return this.__container__.lookup('controller:' + controllerName, options);
  },

  // TODO~ seems bad to refer to default container directly, but
  // probably the thing to do is refactor the NotificationView API to
  // send events to the router rather than create views manually.
  lookupContainer: function(){
    // console.log("TODO: remove reference to PegasusTemplate.lookupContainer()");
    return this.__container__;
  },

  setup: function(options){
    PegasusTemplate.set('options', options);

    PegasusTemplate.handoffHost = function(){
      return options.handoffHost;
    };

    PegasusTemplate.stateMachine = PegasusTemplate.StateMachine.create({
      enableLogging: false
    });
  },
  ready: function(){
    var commandManager = PegasusTemplate.CommandManager.create({
      controller: PegasusTemplate.lookupController('historyOperations')
    });

    PegasusTemplate.IOManager.buildModelForContext( window.editorDocumentType );

    PegasusTemplate.lookupStore().find( PegasusTemplate.Block ).then(function(){
      PegasusTemplate.lookupController('launchPlatform').didRetrieve(PegasusTemplate.Block);
    });

    PegasusTemplate.lookupController('historyOperations').set('content', commandManager);

    var frameCommManager = PegasusTemplate.lookupController('frameCommManager');

    window.addEventListener( 'message', frameCommManager.listen.bind(frameCommManager) );
    frameCommManager.say(window.parent, {
      method: 'requestEditorContext',
      payload: {}
    });

    this.preload();
  },
  showTemplate: function(loaded){
    this.lookupRouter().transitionTo( 'template', loaded );
  },
  teardown: function(){
    PegasusTemplate.lookupController('historyOperations').set('content', []);
    PegasusTemplate.set('options', null);
  },
  preload: function(callback){
    if ( callback ) { callback(); }
  }
});

PegasusTemplate.deferReadiness();
